<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.69632 14.545H3.18117C2.34783 14.545 1.66602 15.2269 1.66602 16.0602C1.66602 16.8935 2.34783 17.5753 3.18117 17.5753H4.69632C5.52965 17.5753 6.21147 16.8935 6.21147 16.0602C6.21147 15.2269 5.52965 14.545 4.69632 14.545ZM10.7569 13.0299H9.24177C8.40844 13.0299 7.72662 13.7117 7.72662 14.545V16.0602C7.72662 16.8935 8.40844 17.5753 9.24177 17.5753H10.7569C11.5903 17.5753 12.2721 16.8935 12.2721 16.0602V14.545C12.2721 13.7117 11.5903 13.0299 10.7569 13.0299ZM16.8175 9.99958H15.3024C14.469 9.99958 13.7872 10.6814 13.7872 11.5147V16.0602C13.7872 16.8935 14.469 17.5753 15.3024 17.5753H16.8175C17.6509 17.5753 18.3327 16.8935 18.3327 16.0602V11.5147C18.3327 10.6814 17.6509 9.99958 16.8175 9.99958ZM17.5751 2.42383H12.5751C11.8933 2.42383 11.5903 3.25716 12.0448 3.71171L13.4842 5.1511C10.6812 8.33292 6.66602 10.7572 2.42359 10.7572C1.96905 10.7572 1.66602 11.0602 1.66602 11.5147C1.66602 11.9693 1.96905 12.2723 2.42359 12.2723C7.49935 12.2723 12.1963 10.8329 15.6054 7.27231L16.969 8.63595C17.4236 9.09049 18.2569 8.78746 18.2569 8.10564V3.1814C18.3327 2.72686 18.0297 2.42383 17.5751 2.42383Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
